import { StationIndicators } from '@app/components/stations/StationIndicators';
import { ListViewLocalChildProps } from '@app/core/list-view/ListViewLocal';
import { Station } from '@app/core/types/stations';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { StationLabel } from './StationLabel';

export type AdminStationsListProps = ListViewLocalChildProps<Station>;

/**
 * Admin stations table for ListViewLocal. Filters live in the DataToolbar.
 */
export function AdminStationsList({
  data,
  isLoading = false,
  isFetching = false,
  showProgress = true,
}: AdminStationsListProps) {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <MrtTable<Station>
        data={data}
        navigateToOnClick={(_id, row) => `/admin/stations/${row.slug}`}
        enableNavigateAction
        enableColumnFilters={false}
        enableGlobalFilter={false}
        enableToolbarInternalActions={false}
        state={{
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
        columns={[
          {
            header: formatMessage({
              id: 'common.text.name',
              defaultMessage: 'Nombre',
            }),
            accessorKey: 'name',
            Cell: ({ row: { original } }) => (
              <Box display="flex" alignItems="center" gap={1}>
                <StationLabel station={original} indicatorsDisplay={false} />
                <StationIndicators station={original} variant="chip" />
              </Box>
            ),
          },
        ]}
      />
    </Box>
  );
}
